<template>
  <router-view></router-view>
  <div class="content">
    <p>{{$t('interestedLanguages.title')}}</p>
    <base-button @click="skipNextPage('All', $event)">{{$t('interestedLanguages.any')}}</base-button>
    <base-button @click="navigateNextPage('AFew', $event)"
      >{{$t('interestedLanguages.AFew')}}</base-button
    >
  </div>
  <div class="pagenumber">
    <label>2/7</label>
  </div>
</template>

<script>
import BaseButton from '../components/UI/BaseButton.vue';
export default {
  data() {
    this.$store.state.interestedLanguages = '';
    return;
  },
  components: { BaseButton },
  methods: {
    navigateNextPage(data) {
      this.$store.state.interestedLanguages = data;
      this.$router.push('/selectlanguages');
    },
    skipNextPage(data) {
      this.$store.state.interestedLanguages = data;
      this.$router.push('/personaldescriptions');
    },
  },
};
</script>
